/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import * as React from "react";
import styled from "@emotion/styled";

export default function LexicalContentEditable({ className }: { className?: string }): JSX.Element {
  return <ContentEditableWrapper />;
}

const ContentEditableWrapper = styled(ContentEditable)`
  border: 0;
  display: block;
  position: relative;
  tab-size: 1;
  outline: 0;
  min-height: calc(100% - 16px);
  font-size: 0.875rem;
  padding: 1rem;
`;
